

type errorProps = {
    message: string[];
}
/**
 * メークアップ登録　エラーメッセージを表示させるコンポーネント
 */
export function ErrorMessage(props: errorProps){
    const msgList = props.message.map( (message, i) => {
        return(
            <li key={i}>{message}</li>
        )
        
    })
    return (
        <div className="error-message-area">
            <div className="message-box">
                <ul>
                    {msgList}
                </ul>
            </div>
        </div>
    )
}